module.exports = __webpack_public_path__ + "static/media/shark_1.b59ad56a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/stock/capetown/shark_1.jpg
// module id = 316
// module chunks = 0